/**
 * Axios API 클라이언트
 * - JWT 토큰 자동 추가
 * - 인터셉터 설정
 */
import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { API_BASE_URL } from '../config/api';

/**
 * Axios 인스턴스 생성
 */
export const apiClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Request 인터셉터
 * - JWT 토큰을 자동으로 헤더에 추가
 */
apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('access_token');
    
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    console.error('❌ API 요청 에러:', error);
    return Promise.reject(error);
  }
);

/**
 * Response 인터셉터
 * - 401 Unauthorized 시 로그아웃 처리
 */
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response) {
      const status = error.response.status;

      // 401 Unauthorized - 로그아웃 처리
      if (status === 401) {
        const { useAuthStore } = await import('../store/authStore');
        useAuthStore.getState().logout();

        // 로그인 페이지로 리다이렉트
        if (
          window.location.pathname !== '/login' &&
          window.location.pathname !== '/signup' &&
          window.location.pathname !== '/auth/callback'
        ) {
          console.warn('🔒 인증 실패 - 로그아웃 처리');
          window.location.href = '/login';
        }
      } else if (status >= 500) {
        console.error(`❌ API 서버 에러 (${status}):`, error.response.data);
      }
      // 4xx (400/403/404 등)는 호출자가 개별 처리 — 콘솔 노이즈 방지
    } else if (error.request) {
      console.warn('❌ API 네트워크 에러:', error.message);
    } else {
      console.error('❌ API 에러:', error.message);
    }

    return Promise.reject(error);
  }
);

export default apiClient;

